<script lang="ts">
import { onBeforeMount, onBeforeUnmount, ref, watch } from 'vue';
import type { AccountNavigationItems, LoginFormType } from '../../CustomerNavigation1XP.vue';
import CustomerNav from '../CustomerNav/CustomerNav.vue';
import LoginForm from '../LoginForm/LoginForm.vue';
import { useStoreTranslations } from '../../../../store/translations/translations';

type Props = {
  loginForm?: LoginFormType;
  items?: AccountNavigationItems[];
  loggedInUser: boolean;
  isOpen: boolean;
};

export type EmitCredentialsType = {
  email: string;
  password: string;
};
</script>
<script setup lang="ts">
const props = defineProps<Props>();
const emit = defineEmits(['login', 'close']);
const isPopperOpen = ref<boolean>(props.isOpen);
const storeTranslations = useStoreTranslations();

watch(
  () => props.isOpen,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      isPopperOpen.value = newValue;
    }
  },
);

const clickOutsideCustomerNav = (e) => {
  const clickedElement = e.target;
  const clickOnCustomerNavButton = clickedElement.closest('.CustomerNavigation1XP__customerButton');
  const clickInCustomerNavPopper = clickedElement.closest(
    '.CustomerNavigation1XP__CustomerNavigationPopper__container',
  );

  if (!(clickOnCustomerNavButton || clickInCustomerNavPopper) && isPopperOpen.value) {
    e.preventDefault();
    emit('close');
  }
};

onBeforeMount(() => {
  window.addEventListener('click', (e) => clickOutsideCustomerNav(e));
});
onBeforeUnmount(() => {
  window.removeEventListener('click', (e) => clickOutsideCustomerNav(e));
});
</script>
<template>
  <div :class="[$style.container, isPopperOpen && $style.isOpen]">
    <div :class="$style.blockHeader">
      <h3>
        {{
          loggedInUser
            ? storeTranslations.translations?.['customerNavPopper.customerNavTitle'] || 'Profile'
            : storeTranslations.translations?.['customerNavPopper.loginFormTitle'] || 'Login'
        }}
      </h3>
      <button :class="$style.closeBtn" @click="() => emit('close')">
        <span class="accessible-link-text">
          {{ storeTranslations.translations?.['customerNavPopper.closeBtn'] || 'Close' }}
        </span>
      </button>
    </div>
    <div :class="$style.blockContent">
      <template v-if="loggedInUser && items">
        <CustomerNav :items="items" />
      </template>
      <template v-if="!loggedInUser && loginForm">
        <LoginForm :login-form="loginForm" @login="(e: EmitCredentialsType) => emit('login', e)" />
      </template>
    </div>
  </div>
</template>
<style lang="scss" module src="./CustomerNavigationPopper.scss" />
